























import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetAssayStatistics, GetBorrowMedStatistics, GetCommonAssayStatistics} from "@/api/report"
import {GetDicsByCode} from "@/api/systemBasic"
import {GetListByCode} from "@/api/configureDictionary"

@Component
export default class Assay extends AbpBase{
	loading = false
	modalShow = false
	query:any = {
		PatientName: '',
		ItemName: ''
	}
	data:any = []
	data1:any = []
	IsOweMed = "全部"
	columns:any = [
		{
			title: '患者姓名',
			key: 'patientName'
		},
		{
			title: '药品名称',
			key: 'itemName'
		},
		{
			title: '结余',
			key: 'balance'
		},
		{
			title: '操作',
			render:(h:any,p:any)=>{
				return h('Button',{
					props:{type: 'primary'},
					on:{
						click:()=>{
							this.detailShow(p)
						}
					}
				},"详情")
			}
		}
	]
	detailShow(p:any){
		this.data1 = p.row.patBorrowMedItems
		this.modalShow = true
	}
	columns1:any = [
		{
			title: '患者姓名',
			key: 'patientName'
		},
		{
			title: '药品名称',
			key: 'itemName'
		},
		{
			title: '操作类型',
			key: 'type'
		},
		{
			title: '操作人',
			key: 'createUser'
		},
		{
			title: '数量',
			key: 'quantity'
		}
	]
	async created(){
		this.getData()
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.modalShow = false
		}
	}
	async getData(){
		this.loading = true
		let query:any = {
			PatientName: this.query.PatientName,
			ItemName: this.query.ItemName
		}
		switch (this.IsOweMed) {
			case "否":
				query.IsOweMed = false
				break
			case "是":
				query.IsOweMed = true
				break
		}
		let res = await GetBorrowMedStatistics(query)
		this.data = res.objects
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/borrow/index.vue